import React from 'react'
import Link from 'gatsby-link'
import { Container } from 'semantic-ui-react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import ReactDOM from 'react-dom'
import StructureData from '../components/StructureData'
import { ContactPoint } from '../components/StructureData'

class Template extends React.Component {

  render() {
    const contactPoint = ContactPoint();
    const Children = this.props.children;
    const props = this.props;
    return (
      <div>
      <Container>
        <Header />
        <StructureData meta={contactPoint} />
        <Children {...props} top={this} />
      </Container>
        <Footer />
      </div>
    )
  }
}

export default Template;



// WEBPACK FOOTER //
// ./src/layouts/index.js